export function renderGenGetPluralContentServerActionTemplate({
  join,
  joinText,
  ctxCacheReadImport,
  ctxCamelPlural,
  sort,
  populateImport,
  dateRangeHelper,
  authorshipAliasBlock,
  columnMapEntries,
  ctxPlural,
  ctxCacheLifeLine,
  ctxSearchBlock,
  ctxFilterConditions,
  ctxListSelectClause,
  ctxTableVar,
  ctxWhere,
  ctxListResultMapping,
  ctxPluralText
}: {
  join: string
  joinText: string
  ctxCacheReadImport: string
  ctxCamelPlural: string
  sort: string
  populateImport: string
  dateRangeHelper: string
  authorshipAliasBlock: string
  columnMapEntries: string
  ctxPlural: string
  ctxCacheLifeLine: string
  ctxSearchBlock: string
  ctxFilterConditions: string
  ctxListSelectClause: string
  ctxTableVar: string
  ctxWhere: string
  ctxListResultMapping: string
  ctxPluralText: string
}): string {
  return `'use server'

import db from '@admin/db'
import { ${join} } from '@admin/db/schema'
import { ${joinText} } from 'drizzle-orm'
import { alias } from 'drizzle-orm/pg-core'
${ctxCacheReadImport}
import { ${ctxCamelPlural}CacheTags } from './types'
import type { ${sort} } from './types'${populateImport}${dateRangeHelper}

${authorshipAliasBlock}

const SORTABLE_COLUMNS = {
${columnMapEntries}
} as const

export async function get${ctxPlural}(query?: ${ctxPlural}Query): Promise<${ctxPlural}Page> {
  'use cache'${ctxCacheLifeLine}
  cacheTag(${ctxCamelPlural}CacheTags.all)

  try {
    const conditions = []
${ctxSearchBlock}${ctxFilterConditions}

    const baseQuery = ${ctxListSelectClause}

    const sortColumn = query?.orderBy && query.orderBy in SORTABLE_COLUMNS
      ? SORTABLE_COLUMNS[query.orderBy as keyof typeof SORTABLE_COLUMNS]
      : ${ctxTableVar}.sortOrder
    const sortFn = query?.orderDirection === 'desc' ? desc : asc
    const orderClause = sortFn(sortColumn)

    const orderedQuery = conditions.length > 0
      ? baseQuery.where(and(...conditions)).orderBy(orderClause)
      : baseQuery.orderBy(orderClause)

    const rawLimit = query?.limit
    const limit = typeof rawLimit === 'number'
      ? Number.isFinite(rawLimit)
        ? Math.max(1, rawLimit)
        : 1
      : undefined
    const rawOffset = query?.offset
    const offset = typeof rawOffset === 'number' && Number.isFinite(rawOffset)
      ? Math.max(0, rawOffset)
      : 0
    const isPaginated = typeof limit === 'number'
    let results: unknown[]
    if (isPaginated) {
      const paginatedQuery = offset > 0
        ? orderedQuery.limit(limit).offset(offset)
        : orderedQuery.limit(limit)
      results = await paginatedQuery
    } else {
      results = await orderedQuery
    }

    const total = isPaginated
      ? Number((await db.select({ count: sql\`count(*)\` }).from(${ctxTableVar})${ctxWhere})[0]?.count ?? 0)
      : results.length${ctxListResultMapping}
  } catch (error) {
    console.error('Error fetching ${ctxPluralText}:', error)
    throw new Error('Failed to fetch ${ctxPluralText}')
  }
}
`
}
